export default "/images/vendor/flag-icons/flags/1x1/ee.svg?5b02e4813fdf56e02d195e30e7aa05ca";